import React, { Component } from 'react';
import { Layout, Menu, Breadcrumb, Input, Col, Typography, Space } from 'antd';

const { Header, Content, Footer } = Layout;
import Test from './components/Header';
import { GithubProvider } from './context/context';
import { LinkedinFilled, FacebookFilled, InstagramFilled} from '@ant-design/icons';

import './App.css';
import Main from './components/Main';

const { Text, Link } = Typography;
const App = () => {
  return (
    <GithubProvider>
      <Layout className="layout__container">
        <Header className="header__container">
          <Test />
        </Header>
        <Content>
          <Col
            xs={8}
            sm={10}
            md={24}
            style={{
              maxWidth: '1280px',
              margin: '0 auto',
            }}>
            <Main />
          </Col>
        </Content>
        <Footer style={{ textAlign: 'left', maxWidth: "1280px" }}>
          <Text> 2020 © Founders Lair</Text>
          <div className="icons-list">
            <LinkedinFilled className="icons" />
            <FacebookFilled className="icons" />
            <InstagramFilled  className="icons"/>
          </div>
        </Footer>
      </Layout>
    </GithubProvider>
  );
};

export default App;
